module.exports = __webpack_public_path__ + "static/media/Investors.840f9007.jpg";